
import { NgModule } from '@angular/core';
import { ThemeModule } from '../@theme/theme.module';
import { CommonModule } from '@angular/common';
import {
  NbMenuModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbDialogModule,
  NbAccordionModule
} from '@nebular/theme';


import { MainComponent } from './main.component';
import { MainRoutingModule } from './main-routing.module';
import { HomeComponent } from './sys/home/home.component';
import { Ng2SmartTableModule, ɵw as PagerModule } from 'ng2-smart-table';
import { ToolModule } from '../tool/tool.module';


@NgModule({  
  imports: [
    CommonModule,
    NbCardModule,
    NbButtonModule,
    NbDialogModule.forChild(),
    NbIconModule,
    NbAccordionModule,
    ThemeModule,
    NbMenuModule,
    MainRoutingModule,
    Ng2SmartTableModule,
    PagerModule,
    ToolModule
  ],
  declarations: [
    MainComponent,
    HomeComponent,
    
    
  ],
})
export class MainModule {

  
} 



